import React from "react";

import TerminationPaymentPanel from "./TerminationPaymentPanel";

type Props = {
  token: string;
  contractId: string;
  employeeName: string;
  onClose: () => void;
};

/** O demonstrativo de rescisão (F2c) aberto pela ficha, aba Contratos, no contrato rescindido. */
export default function TerminationPaymentModal({ token, contractId, employeeName, onClose }: Props) {
  return (
    <div className="dpModalOverlay">
      <div className="dpModal dpModal--wide">
        <header className="dpModal__header">
          <h2 className="dpModal__title">Verbas rescisórias (conferência) — {employeeName}</h2>
          <button className="dpModal__close" onClick={onClose}>
            &times;
          </button>
        </header>
        <div className="dpModal__body">
          <TerminationPaymentPanel token={token} contractId={contractId} employeeName={employeeName} />
        </div>
      </div>
    </div>
  );
}
